import { Formik } from 'formik';

import { AssignmentMessage } from '../../../../types/AssignmentMessage';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';
import { useAssignmentUpdate } from '../hooks/useAssignmentUpdate';

import { AssignmentBaseForm, FormikAssignmentState } from './AssignmentBaseForm';
import { validateAssignment } from './validateAssignment';

interface EditAssignmentDrawerProps {
    assignment: AssignmentMessage;
    onSuccess: () => void;
}

export const EditAssignmentDrawer = ({ assignment, onSuccess }: EditAssignmentDrawerProps) => {
    const { addErrorToast } = useToasts();
    const updateAssignmentMutation = useAssignmentUpdate(assignment.id);

    const initialValues: FormikAssignmentState = {
        customerId: assignment.customerId,
        supplierId: assignment.supplierId,
    };

    const handleSubmit = async (values: FormikAssignmentState) => {
        const requestMessage: AssignmentMessage = {
            ...assignment,
            customerId: values.customerId,
            supplierId: values.supplierId,
        };

        await updateAssignmentMutation.mutateAsync(requestMessage, {
            onSuccess,
            onError: () => {
                addErrorToast(translate('assignments.toasts.updateError'));
            },
        });
    };

    return (
        <Formik validate={validateAssignment} initialValues={initialValues} onSubmit={handleSubmit}>
            <AssignmentBaseForm primaryActionText={translate('assignments.update')} />
        </Formik>
    );
};
